<template>
  <div class="camera-feed">
    <video ref="video" playsinline autoplay></video>
  </div>
</template>

<script>
export default {
  name: 'CameraFeed',

  mounted() {
    const { video } = this.$refs;

    navigator.mediaDevices.getUserMedia({
      audio: false,
      video: { facingMode: { ideal: 'environment' } },
    }).then((stream) => {
      video.srcObject = stream;
      window.dispatchEvent(new CustomEvent('cameraallow'));
    }).catch(() => {
      window.dispatchEvent(new CustomEvent('cameraallow')); // TODO: Back to erro here
    });
  },
};
</script>

<style lang="scss">
.camera-feed {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;

  video {
    width: 100%;
    height: 100%;

    object-fit: cover;
  }
}
</style>
